import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { getTestimonials } from "../lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    getTestimonials().then(setItems).catch(() => {});
  }, []);

  return (
    <div data-testid="testimonials-page">
      <PageHeader
        eyebrow="Student Voices"
        title="Testimonials"
        subtitle="Words from students, alumni, parents, and well-wishers who have experienced the college community."
      />

      <section className="py-16 lg:py-24 bg-brand-ivory">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {items.length > 0 ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6" data-testid="testimonials-grid">
              {items.map((item, i) => (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.35, delay: i * 0.04 }}
                  className="bg-white rounded-3xl p-6 lg:p-7 border border-brand-primary/10 shadow-[0_8px_30px_rgba(15,76,58,0.05)]"
                >
                  <Quote className="w-8 h-8 text-brand-secondary mb-5" />
                  <p className="text-brand-ink/75 leading-relaxed mb-6">
                    {item.message}
                  </p>
                  <div className="font-serif text-2xl text-brand-primary leading-tight">
                    {item.name}
                  </div>
                  {item.role && (
                    <div className="text-xs uppercase tracking-[0.2em] text-brand-muted mt-1">
                      {item.role}
                    </div>
                  )}
                </motion.div>
              ))}
            </div>
          ) : (
            <div className="bg-white rounded-3xl p-10 text-center text-brand-muted border border-brand-primary/10">
              Testimonials will appear here after they are added from the admin panel.
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
